module.exports = __webpack_public_path__ + "static/media/hero-right.ba16a6d6.svg";